/** Confirm step before tag Replace overwrites visible tags on every selected model. */
import type { MfgRecipeSummary } from "@/lib/manufacturing/types";
import {
  ghostBtnClass,
  adminDangerGhostBtnClass,
} from "@/components/manufacturing/manufacturingSurfaceClasses";

export function ManufacturingModelsBulkReplaceTagsConfirm({
  recipes,
  tagsParsed,
  busy,
  error,
  onConfirm,
  onBack,
}: {
  recipes: readonly MfgRecipeSummary[];
  tagsParsed: readonly string[];
  busy: boolean;
  error: string | null;
  onConfirm: () => void;
  onBack: () => void;
}) {
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-black/40 p-4">
      <div className="mt-10 w-full max-w-lg rounded-lg border border-amber-300 bg-white p-4 shadow-xl dark:border-amber-700 dark:bg-zinc-900">
        <h3 className="text-base font-semibold text-amber-950 dark:text-amber-100">
          Replace tags on all selected models?
        </h3>
        <p className="mt-2 text-sm text-gray-700 dark:text-zinc-300">
          This overwrites visible tags on every model below
          {tagsParsed.length === 0
            ? " (clearing them)."
            : ` with: ${tagsParsed.join(", ")}.`}{" "}
          Machine variant config tags are preserved.
        </p>
        <ul className="mt-3 max-h-64 overflow-y-auto rounded-md border border-gray-200 text-sm dark:border-zinc-700">
          {recipes.map((r) => (
            <li
              key={r.id}
              className="border-b border-gray-100 px-3 py-1.5 last:border-b-0 dark:border-zinc-800"
            >
              <span className="font-medium">{r.code}</span>
              <span className="text-gray-600 dark:text-zinc-400"> · {r.name}</span>
            </li>
          ))}
        </ul>
        {error ? (
          <div className="mt-2 text-sm text-red-600 dark:text-red-400">{error}</div>
        ) : null}
        <div className="mt-4 flex flex-wrap gap-2">
          <button
            type="button"
            className={adminDangerGhostBtnClass}
            disabled={busy}
            onClick={onConfirm}
          >
            {busy ? "Applying…" : `Replace tags on ${recipes.length} models`}
          </button>
          <button type="button" className={ghostBtnClass} disabled={busy} onClick={onBack}>
            Back
          </button>
        </div>
      </div>
    </div>
  );
}
